<template>
    <div>

        <b-container fluid style="background-color:#f5f5f5f5">
            <b-container class="phone">
                <b-row style="min-height: 100vh" align-h="center" align-v="center"> 
                    <!-- Descricao plataforma -->
                    <b-col sm="12" md="5" class="description text-center">
                        <div>
                            <span>
                                <router-link to="/">
                                    <home-icon size="2x" class="resize"></home-icon>
                                </router-link>
                            </span>
                        </div>


                        <div style="border-radius: 100px; display: inline-block; border: 2px #f5f5f5f5 solid; padding: 3px; margin-top: 10px">
                            <div style="background-color: #f5f5f5f5; display: inline-block; border-radius: 100px;">
                                <img src="../../assets/logo.png" alt="" width="100" height="100">
                            </div>
                        </div>
                        
                        <h3>
                            NefroAtlas
                        </h3>

                        <div class="text-justify" style="padding: 15px;">
                            <p>
                                NefroAtlas é uma plataforma de ensino com foco no estudo das doenças renais. Cada módulo
                                será construído objetivando atingir pontos específicos no aprendizado da Nefrologia, através
                                da contextualização de imagens médicas com casos clínicos.
                            </p>
                            <p>
                                O NefroAtlas é um produto desenvolvido pela colaboração de professores e alunos do
                                Mestrado Profissional em Ensino na Saúde (MPES-UFRN), do Instituto Metrópole Digital
                                (UFRN) e do Laboratório de Patologia da UFMA (São Luis-MA).
                            </p>
                        </div>

                    </b-col>
                    <!-- signin e signup -->
                    <b-col class="sign" sm="12" md="5">
                        <router-view></router-view>
                    </b-col>
                </b-row>
            </b-container>
        </b-container>

    </div>
</template>

<script>
import { HomeIcon } from 'vue-feather-icons'
export default {
    components: {
        HomeIcon
    }
}
</script>

<style scoped>
    .description, .sign {
        background-color: #71c55d;
        width: 100%;
        height: 450px;
    }
    .sign {
        background-color: #2cb5e8;
    }

    .description {
         font-size: 15px;
    }

    h3 {
        padding-top: 10px;
    }

    @media screen and (max-width: 578px){
        .phone {
            margin: 0;
            padding: 0;
        }
        .description {
            font-size: 13.5px;
        }
    }
    .resize {
        position: absolute;
        top: 15px;
        left: 15px;
        color: #f5f5f5;
        transition: .5s;
    }
    .resize:hover {
        color: #f5f5f583;
        transition: .5s;
    }
</style>